// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSearch: React.FC = () => {
    return (
        <svg
            width="15px"
            height="16px"
            viewBox="0 0 15 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Input-Fields/Form-:-Search/Form-:-Search-:-Small"
                    transform="translate(-236.000000, -9.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g transform="translate(226.000000, 0.000000)">
                        <g transform="translate(9.999994, 9.875000)">
                            <path d="M14.7685607,13.7988281 L10.8427794,9.87304688 C11.6923888,8.83300781 12.1611388,7.52343714 12.1611388,6.09375 C12.1611388,2.72753924 9.43272069,0 6.0673888,0 C2.70205691,0 0,2.72841811 0,6.09375 C0,9.45908189 2.72813112,12.1875 6.06738925,12.1875 C7.49678403,12.1875 8.80811244,11.6920897 9.84668612,10.8679685 L13.7724674,14.7937497 C13.9365301,14.9326175 14.1181701,15 14.2968813,15 C14.4755924,15 14.6566468,14.9313283 14.7940493,14.7940135 C15.0673887,14.5195314 15.0673887,14.0742186 14.7685611,13.7988281 L14.7685607,13.7988281 Z M1.40625626,6.09375 C1.40625626,3.50917965 3.50918591,1.40625 6.09375626,1.40625 C8.67832661,1.40625 10.7812563,3.50917965 10.7812563,6.09375 C10.7812563,8.67832035 8.67832661,10.78125 6.09375626,10.78125 C3.50918591,10.78125 1.40625626,8.67773473 1.40625626,6.09375 Z"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconSearch);
